export const getUpdates = (prevState, newState, keys) =>
  keys.reduce(
    (result, key) => ({
      ...result,
      [key]: prevState[key] !== newState[key],
    }),
    {}
  );

export const isLoaded = () =>
  IS_BROWSER && typeof window.apntag !== 'undefined';

export const get = () => (isLoaded() ? window.apntag : null);

export default {
  getUpdates,
  isLoaded,
  get,
};
